import React, { useMemo } from 'react'

import { Button } from '@wartek-id/button-v1'

import PanelKinerja from 'app/KinerjaPage/components/PanelKinerja'
import useContentContext from 'app/KinerjaPage/hooks/useContentContext'
import StickyFooter from 'app/KinerjaPage/components/StickyFooter'

import type { Kinerja } from 'types/kinerja'

interface TabHasilKerjaUtamaProps {
  skp: Kinerja
  onClickNext?: () => void
}

const TabHasilKerjaUtama = ({
  skp,
  onClickNext = () => {},
}: TabHasilKerjaUtamaProps) => {
  const {
    getPraktikPembelajaranById,
    getPengembanganKompetensiById,
    getKinerjaUtamaById,
  } = useContentContext()

  const praktikPembelajaran = useMemo(
    () => getPraktikPembelajaranById(skp.praktikPembelajaran),
    [skp, getPraktikPembelajaranById]
  )

  return (
    <>
      <div className="p-9">
        <div className="flex flex-col gap-9">
          <PanelKinerja
            data-testid="praktikPembelajaran"
            number={1}
            kinerja={praktikPembelajaran}
          />
          {skp.pengembanganKompetensi.map(({ id, kuantitas }, i) => {
            const index = i + 1
            const pengembanganKompetensi = getPengembanganKompetensiById(id)

            return (
              <PanelKinerja
                key={`pengembanganKompetensi-${index}`}
                data-testid={`pengembanganKompetensi-${index}`}
                number={index + 1}
                kinerja={{
                  ...pengembanganKompetensi,
                  targetKuantitas: `${kuantitas} kegiatan`,
                  bobot: pengembanganKompetensi.bobot * kuantitas,
                }}
              />
            )
          })}
          {skp.kinerjaUtama.map((id, i) => {
            const index = i + skp.pengembanganKompetensi.length
            const kinerjaUtama = getKinerjaUtamaById(id)

            return (
              <PanelKinerja
                key={`kinerjaUtama-${index}`}
                data-testid={`kinerjaUtama-${index}`}
                number={index + 2}
                kinerja={kinerjaUtama}
              />
            )
          })}
        </div>
      </div>

      <StickyFooter>
        <Button
          size="lg"
          color="black"
          onClick={() => onClickNext()}
          type="button"
          data-testid="btn-next"
        >
          Ke Hasil Kerja Tambahan
        </Button>
      </StickyFooter>
    </>
  )
}

export default TabHasilKerjaUtama
